module.exports = __webpack_public_path__ + "img/join-banner-xs.3afcca91.jpg";